<!-- <mat-toolbar>
    <mat-toolbar-row>
        <span>
            <a href="/inicio">
                <img src="../../../assets/images/logolascondes.png" alt="Inicio icono" width="190px" height="90px">
            </a>
        </span>
        <span class="example-spacer"></span>
        <div *ngIf="!identity || !token">
            <button mat-button (click)="sign(true, 'expedientes')">
                <mat-icon mat-button>touch_app</mat-icon>
                Iniciar sesión
            </button>
        </div>
        <div *ngIf="identity || token">
            <button mat-button style="color: white !important" (click)="openPerfil()">
                {{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}
            </button>
            <button mat-button [matMenuTriggerFor]="menu">
                <mat-icon mat-button [matMenuTriggerFor]="menu">settings
                </mat-icon> Opciones
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item href="">
                    <mat-icon>build
                    </mat-icon>Ajustes
                </button>
                <button mat-menu-item href="" (click)="logout()">
                    <mat-icon>exit_to_app
                    </mat-icon>Cerrar Sesi&oacute;n
                </button>
            </mat-menu>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
<div class="linea"></div>

<div class="divPrincipal">
    <div @items class="col-md-12 col-sm-12 ">
        <div class="container">
            <h1 class="mat-h1 divTitulo">
                <strong><span class="spanDom">Smart</span> <span class="spanCloud"> DOM</span> - <span class="spanDom"> <img
                        src="assets/images/logocondessf.png" height="90px"> MUNICIPALIDAD DE LAS CONDES</span></strong>
            </h1>
            <h2 class="subTitulo">
            <strong> Tus trámites de obra en línea</strong>
            </h2>
        </div>
        <div class="container">
            <div style="text-align: center ; padding-bottom: 50px;">
            <span class="servicioSpan"><strong> Servicios</strong></span>
            </div>
            <div class="col-md-3 col-sm-3 cardOptions" *ngFor="let item of options" align="center">
                <mat-card class="muni-card" (click)="sign(item.active, item.url)" align="center">
                    <mat-card-header align="center">
                        <div class="col-md-12 col-sm-12 mat-name" align="center">
                            <mat-card-title>
                                <h2 class="subTitulo2">
                                    <strong>{{item.name}}</strong>
                                </h2>
                            </mat-card-title>
                        </div>
                    </mat-card-header>
                    <mat-card-content class="contentcard" align="center">
                        <img class="iconService" mat-card-image [src]="item.img">
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
     <footer>
        <div style="background-color: #262626; color: white">
            <p align="center">MUNICIPALIDAD DE LAS CONDES - DIRECCION DE OBRAS</p>
            <p align="center">Av Maquehue 1441</p>
            <p align="center"><a href="www.lascondes.cl">www.lascondes.cl</a></p>
        </div>
    </footer> 
</div> -->
<div class="header">
    <span>
        <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
    </span>
</div>


<div>
    <img src="/assets/images/generico/bnr3.png" class="bnr1">
</div>

<div class="title1"> Servicios</div>

<div class="bg-color">

    <section class="wrapper">
        <div class="container-fostrap">

            <div class="content">
                <div class="container">
                    <div class="row">
                        <div *ngFor="let item of options">
                            <div class="col-xs-12" [ngClass]="(contActivos>3)?'col-sm-3':'col-sm-4'" *ngIf="item.active &&  (nombreMuni=='Prueba Solnet'?(item.name=='Expedientes'||item.name=='BNUP'||item.name=='Inspeccion' || item.name=='Certificados'?true:false || item.name=='Totem'?true:false):true)">
                                <div class="card" *ngIf="item.active &&  (nombreMuni=='Prueba Solnet'?(item.name=='Expedientes'||item.name=='BNUP' ||item.name=='Inspeccion' || item.name=='Certificados'?true:false || item.name=='Totem'?true:false):true) ">
                                    <a class="img-card" (click)="sign(item.active, item.url)">
                                        <img src="{{item.img}}" />
                                    </a>
                                    <div class="card-content" (click)="sign(item.active, item.url)">
                                        <h4 class="card-title">
                                            <a>{{ item.name }}</a>
                                        </h4>
                                        <p class="parag"> {{ item.description }} </p>
                                    </div>
                                    <div class="card-read-more">
                                        <a class="btn btn-link btn-block" (click)="sign(item.active, item.url)">Ver</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="ftr">
        <p class="ftr-txt">{{footer}}</p>
        <a [href]="webUrl" target="_blank"> {{web}}</a>
    </section>
</div>
<!-- Routed view  -->
<router-outlet></router-outlet>